<div class="eb-shipping-address__edit-address-modal">
  <div class="cx-modal-content">
    <div class="modal__wrapper">
      <ng-container>
        <div class="modal__header">
          <div class="modal__title">
            <h3>{{ 'shippingAddress.edit.title' | cxTranslate }}</h3>
            <button
              type="button"
              class="modal__close"
              (click)="dismissModal('cross click')"
              data-cy="modal-close"
            >
              <em class="fas fa-times"></em>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <form
            [formGroup]="shippingAddressForm"
            class="eb-shipping-address__edit-address-form"
            (ngSubmit)="chooseSubmit()"
          >
            <label for="companyName">
              <span>{{ 'shippingAddress.edit.companyName' | cxTranslate }}</span>
              <input id="companyName" type="text" formControlName="companyName" [maxlength]="70" />
            </label>
            <label for="street" class="form-field__shared-line-bigger">
              <span>{{ 'shippingAddress.edit.street' | cxTranslate }}</span>
              <input id="street" type="text" formControlName="street" [maxlength]="35" />
            </label>
            <label for="houseNumber" class="form-field__shared-line-smaller">
              <span>{{ 'shippingAddress.edit.houseNumber' | cxTranslate }}</span>
              <input id="houseNumber" type="text" formControlName="houseNumber" [maxlength]="10" />
            </label>
            <label for="city" class="form-field__shared-line-bigger">
              <span>{{ 'shippingAddress.edit.city' | cxTranslate }}</span>
              <input id="city" type="text" formControlName="city" [maxlength]="35" />
            </label>
            <label for="zip" class="form-field__shared-line-smaller">
              <span>{{ 'shippingAddress.edit.zip' | cxTranslate }}</span>
              <input id="zip" type="text" formControlName="zip" [maxlength]="10" />
            </label>
            <label for="country">
              <span>{{ 'shippingAddress.edit.country' | cxTranslate }}</span>
              <input id="country" type="text" formControlName="country" />
            </label>
            <label for="additionalInformation">
              <span>{{ 'shippingAddress.edit.additionalInformation' | cxTranslate }}</span>
              <input
                id="additionalInformation"
                type="text"
                formControlName="additionalInformation"
                [maxLength]="35"
                [placeholder]="
                  'shippingAddress.edit.additionalInformationPlaceholder' | cxTranslate
                "
              />
            </label>
            <input id="id" type="text" formControlName="id" style="visibility: hidden" />
            <input
              id="ebCommerceAddress"
              type="text"
              formControlName="ebCommerceAddress"
              style="visibility: hidden"
            />
            <div class="eb-shipping-address__edit-address-modal-action-buttons">
              <a
                class="eb-shipping-address__edit-address-modal-cancel"
                (click)="dismissModal('cancel')"
              >
                {{ 'shippingAddress.edit.cancel' | cxTranslate }}
              </a>
              <button type="submit" class="eb-shipping-address__edit-address-modal-submit">
                {{ 'shippingAddress.edit.saveChanges' | cxTranslate }}
              </button>
            </div>
          </form>
        </div>
      </ng-container>
    </div>
  </div>
</div>
